module.exports = __webpack_public_path__ + "static/media/lecture-video-recorder.549c4510.jpg";